module.exports = __webpack_public_path__ + "img/flicker_orange2.3a128b85.gif";